export default {
  h1_edu: "Cursos educativos para médicos diagnósticos",
  Lessons: {
    Lesson: {
      title: "Lección",
      Files: "Archivos adjuntos",
      DownloadAll: "Descargar todo",
    },
    status: {
      success: "Completado",
      unsuccess: "No completado",
      stop: "No disponible",
    },
  },
};
